<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 17 16"
    fill="none"
    :class="className"
  >
    <path
      d="M7.44043 0.698242C7.81819 0.59496 8.21437 0.582649 8.59668 0.660156L8.75977 0.698242L13.8594 2.09277C14.9463 2.38994 15.7002 3.37809 15.7002 4.50488V10.4297C15.7002 11.4221 15.1141 12.3138 14.2188 12.7129L14.0352 12.7861L8.93555 14.5938C8.46282 14.7613 7.95191 14.7819 7.46973 14.6562L7.26465 14.5938L2.16504 12.7861C1.16711 12.4325 0.500015 11.4884 0.5 10.4297V4.50488C0.5 3.44856 1.16229 2.51376 2.14062 2.15625L2.34082 2.09277L7.44043 0.698242Z"
      fill="url(#paint0_radial_5042_217799)"
      stroke="url(#paint1_linear_5042_217799)"
    />
    <text
      class="text-[0.4375rem] text-white"
      fill="white"
      y="10"
      :x="badgeNumber === 1 ? '7' : badgeNumber < 10 ? '6' : '5'"
    >
      {{ badgeNumber }}
    </text>
    <defs>
      <radialGradient
        id="paint0_radial_5042_217799"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(8.1 0.984255) rotate(90) scale(14.4357 15.166)"
      >
        <stop stop-color="#314825" />
        <stop offset="1" stop-color="#1E2A21" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_5042_217799"
        x1="8.1"
        y1="0"
        x2="8.1"
        y2="15.42"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E2E950" />
        <stop offset="1" stop-color="#22AF30" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'

export default defineComponent({
  name: 'BadgeIcon',
  props: {
    badgeNumber: {
      type: Number,
      default: 0
    },
    width: {
      type: [Number, String],
      default: 16
    },
    height: {
      type: [Number, String],
      default: 16
    },
    class: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    const className = computed(() => props.class)

    return {
      className
    }
  }
})
</script>
